/* Custom By Benjamin */

// Add a new form field
document.addEventListener('DOMContentLoaded', () => {
  const select = document.getElementById('ContactForm-Select');
  const otherWrapper = document.getElementById('ContactForm-CommandOrder-Block');
  const otherInput = document.getElementById('ContactForm-CommandOrder');

  if (!select || !otherWrapper || !otherInput) return;

  function toggleOtherField() {
    if (select.value === 'Commande') {
      otherWrapper.style.display = 'block';
      otherInput.setAttribute('required', 'required');
    } else {
      otherWrapper.style.display = 'none';
      otherInput.removeAttribute('required');
      otherInput.value = '';
    }
  }

  select.addEventListener('change', toggleOtherField);
  toggleOtherField(); // état initial
});

document.addEventListener('DOMContentLoaded', function() {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  var buttons = document.querySelectorAll('a.button, .btn a');
  buttons.forEach(function(button) {
    if (button.hostname !== window.location.hostname) {
      button.target = '_blank';
      button.rel = 'noreferrer noopener';
    }
  });
});

